import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { HostFamilyLecComment } from '../../../lib/types/models/host-family-lec-comment/host-family-lec-comment'
import { HostFamilyLecCommentFilters } from '../../../lib/types/models/host-family-lec-comment/host-family-lec-input'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getHostFamilyLecComments(
  input: PaginationRequest<HostFamilyLecCommentFilters> & { hostFamilyId: number }
) {
  const { hostFamilyId, ...rest } = input
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.hostFamilies.getHostFamilyLecComments.url, { hostFamilyId }),
        rest
      )
    )
    .get<PaginationResponse<HostFamilyLecComment>>()
}
